<script setup>
import { defineProps, ref, onMounted, computed } from 'vue';
import SelectBoxV2 from '@/components/cloudCounter/SelectBox.v2.vue';
import { getBankInfo, postBranchBankInfo } from '@/apis/beneficiaryChange';
import Loading from '@/components/Loading.vue';

const props = defineProps({
    value: Object,
    changeHandel: Function,
});
// value.bankCode: String,
// value.bankBranch: String,
// value.bankAccount: String,

const isLoading = ref(false);
const bankData = ref([]);
const bankBranchData = ref([]);

const bankOptions = computed(() => {
    let temp = ['']; //空值(因為非必填)
    return temp.concat(bankData.value.map(i => `${i.bankNo} ${i.bankName}`));
});

const bankBranchOptions = computed(() => {
    return bankBranchData.value?.map(i => `${i.bankNo} ${i.bankName}`);
});

async function changeBank() {
    props.value.bankBranch = "";
    props.value.bankAccount = "";
    if (props.value.bankCode !== '') {
        await fetchBranchBankInfo(props.value.bankCode.split(" ")[0]);
        if (bankBranchData.value?.length === 1) { // SelectBoxV2 只有一筆時不會開啟選單，就預設給第一筆吧
            props.value.bankBranch = `${bankBranchData.value[0].bankNo} ${bankBranchData.value[0].bankName}`;
        }
    } else {
        bankBranchData.value = [];
    }
}

/**
 * API
 */
//取銀行總行選單
const fetchBankInfo = async () => {
    isLoading.value = true;
    try {
        const resp = await getBankInfo();
        bankData.value = resp.data.bankInfoList;
    } catch (e) {
        console.log(e);
    } finally {
        isLoading.value = false;
    }
};

//取銀行分行選單
const fetchBranchBankInfo = async (bankNo) => {
    isLoading.value = true;
    try {
        if (bankNo) {
            const resp = await postBranchBankInfo(bankNo);
            bankBranchData.value = resp.data?.branchBankInfoList;
        }
    } catch (e) {
        console.log(e);
        bankBranchData.value = [];
    } finally {
        isLoading.value = false;
    }
};

/**
 * Hook
 */
onMounted(async () => {
    await fetchBankInfo();
    if (props.value.bankCode !== '') fetchBranchBankInfo(props.value.bankCode.split(" ")[0]);
});

</script>

<template>
    <div class="pb-2">
        <SelectBoxV2 :selectOptions="{
            selectValue: value.bankCode,
            setValue: (data) => value.bankCode = data,
            placeholder: '請選擇銀行代碼',
            boxData: {
                boxTitle: '請選擇銀行代碼',
                options: bankOptions,
            }
        }" :changeHandel="() => { changeBank(); changeHandel() }" />
    </div>
    <div class="pb-2">
        <SelectBoxV2 :selectOptions="{
            selectValue: value.bankBranch,
            setValue: (data) => value.bankBranch = data,
            placeholder: '請選擇分行',
            boxData: {
                boxTitle: '請選擇分行',
                options: bankBranchOptions,
            },
        }" :changeHandel="changeHandel" />
    </div>
    <input type="text" placeholder="帳戶號碼" v-model="value.bankAccount" @input="(e) => { changeHandel() }"
        :disabled="!value.bankCode" />
    <div class="error-msg">
        {{ value.bankCode && !value.bankAccount ? '帳戶號碼未填寫，請確認！' : '' }}
    </div>
    <Loading :is-loading="isLoading" />
</template>

<style scoped></style>
